import {
	AccountsV2Response,
	FinancingAccountV2ResponseLoanTypeEnum,
	LoanResponseStatusEnum,
} from '../../types/generated/pos';

export type ApiAccountData = AccountsV2Response;
export const LoanTypes = FinancingAccountV2ResponseLoanTypeEnum;
export const AccountStatuses = LoanResponseStatusEnum;
